var FalseDeliveryFormJs = (function ($) {

    var numberRegex = /^\d+$/;
    var emailRegex = /^([a-zA-Z0-9_\.\-\+])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$/;
    var maxOrderNumberInputs = 10;
    var orderNumberInputCounter = 1;

    function validInputs() {
        var isValid = true;
        $(".false-delivery-form-container .form-control").each(function () {
            var inputType = $(this).prop('type');
            switch (inputType) {
                case 'text':
                    isValid = checkTextInput($(this), isValid);
                    break;
                case 'email':
                    isValid = checkEmailInput($(this),isValid);
                    break;
                case 'checkbox':
                    isValid = checkBoxChecked($(this),isValid);
                    break;
                case 'select-one':
                    isValid = checkSelected($(this),isValid);
                    break;
            }
        });
        return isValid;
    }

    function checkTextInput(input, isValid) {
        var name = input.attr('name');
        if (name === "customerNumber") {
            return isValid;
        } else if (input.val().length !== 0 && input.val() !== "") {
            if (name !== "rdNumbers" && name !== "phone-copy" && name !== "deliveredQuantity") {
                return isValid;
            }

            if (name === "rdNumbers" || name === "phone-copy" || name === "deliveredQuantity") {
                if (numberRegex.test(input.val())) {
                    return isValid;
                } else {
                    return false;
                }
            }
        } else {
            return false;
        }
    }

    function checkEmailInput(input, isValid) {
        if (emailRegex.test(input.val())) {
            return isValid;
        } else {
            return false;
        }
    }

    function checkBoxChecked(input, isValid) {
        if (input.is(':checked')) {
            return isValid;
        } else {
            return false;
        }
    }

    function checkSelected(input, isValid) {
        if (input.val() !== null) {
            return isValid;
        } else {
            return false;
        }
    }

    function registerFalseDelivery() {
        var recaptchaResponse = ReifendirektCaptchaAddOnJs.getRecaptchaResponse('falseDelivery_recaptcha');
        var csrfToken = $("input[name='_csrf']").val();
        $.ajax({
            type: "POST",
            url: "/order/register-false-delivery?g-recaptcha-response=" + recaptchaResponse,
            headers: {
                "X-CSRF-TOKEN": csrfToken
            },
            data: $("#false-delivery-form").serialize(),
            success: function (data) {
                window.location.replace("/order/false-delivery-form/success");
            },
            error: function (data) {
                $(".false-delivery-error-default").show();
                $("#false-delivery-form-submit-button").attr("disabled", false);
            }
        });
    }

    function initFalseDelivery() {
        var contactFormContainer = $(".false-delivery-form-container").first();
        contactFormContainer.find("#false-delivery-form").on('submit', function (event) {
            event.preventDefault();
            if (ReifendirektCaptchaAddOnJs.isInvisibleCaptchaEnabled()) {
                ReifendirektCaptchaAddOnJs.executeRecaptcha('falseDelivery_recaptcha');
            } else {
                registerFalseDelivery();
            }
        });

        $(".false-delivery-form-container .form-control").on('change', function () {
            checkFields($(this));
        });

        $(".false-delivery-add-order-number").on('click', function () {
            addOrderNumberInput(contactFormContainer);
            checkFields($(this));
        });
    }

    function checkFields(data) {
         var inputName = data.attr('name');
        switch (inputName) {
            case 'rdNumbers':
                checkRdnr(data);
                break;
            case 'phone-copy':
                checkPhone(data);
                break;
            case 'termsCheckbox':
                checkCheckbox(data);
                break;
            case 'email':
                checkEmail(data);
                break;
            case 'deliveredQuantity':
                checkQuantity(data);
                break;
            default:
                checkOther(data);
                break;
        }
        if (validInputs()) {
            $("#false-delivery-form-submit-button").removeAttr("disabled");
        } else {
            $("#false-delivery-form-submit-button").attr("disabled", "disabled");
        }
    }

    function checkError(input, regex, emptyError, inputError) {
        if (input.val() === "") {
            emptyError.show();
            inputError.hide();
        } else {
            if (emptyError.css('display') === 'block') {
                emptyError.hide();
            }
            if (regex.test(input.val())) {
                inputError.hide();
            } else {
                inputError.show();
            }
        }
    }

    function checkRdnr(input) {
        if (input.hasClass("anotherRdNumber")) {
            var emptyError = input.closest("div.false-delivery-new-order-number-input-wrapper").find(".false-delivery-anotherRdnr-error-div");
            var inputError = input.closest("div.false-delivery-new-order-number-input-wrapper").find(".anotherRdnr-incorrect-input-format");
        } else {
            var emptyError = $(".false-delivery-rdnr-error-div");
            var inputError = $(".rdnr-incorrect-input-format");
        }
        checkError(input, numberRegex, emptyError, inputError);
    }

    function checkPhone(input) {
        var emptyError = $(".phone-error-div");
        var inputError = $(".phone-incorrect-input-format");
        checkError(input, numberRegex, emptyError, inputError);
    }

    function checkEmail(input) {
        var emptyError = input.next();
        var inputError = input.siblings(".email-incorrect-input-format");
        checkError(input, emailRegex, emptyError, inputError);
    }

    function checkQuantity(input) {
        var emptyError = input.next();
        var inputError = input.siblings(".quantity-incorrect-input-format");
        checkError(input, numberRegex, emptyError, inputError);
    }

    function checkCheckbox(input) {
        if (!input.is(':checked')) {
            input.nextAll('.false-delivery-policy-error-div').first().show();
        } else {
            if (input.nextAll('.false-delivery-policy-error-div').first().css('display') === 'block') {
                input.nextAll('.false-delivery-policy-error-div').first().hide();
            }
        }
    }

    function checkOther(input) {
        if (input.val() === "") {
             input.next().show();
        } else {
            if (input.next().css('display') === 'block') {
                input.next().hide();
            }
        }
    }

    function addOrderNumberInput(contactFormContainer) {
        if (orderNumberInputCounter === maxOrderNumberInputs) {
            return;
        }

        var wrapperDiv = $("<div>").addClass("false-delivery-new-order-number-input-wrapper");
        var orderNumberControlContainer = $("<div>").addClass("false-delivery-order-number-control-container");

        var newOrderNumberInput = $("<input>")
            .addClass("form-control order-number-field anotherRdNumber")
            .attr("name", "rdNumbers")
            .attr("type", "text")
            .on('change', function () {
               checkFields($(this));
            });

        var orderEmptyText = contactFormContainer.find(".false-delivery-rdnr-error-div").first().text();
        var errorEmptyDiv = $("<div>")
            .addClass("false-delivery-anotherRdnr-error-div")
            .text(orderEmptyText);

        var orderNumberInvalidText = contactFormContainer.find(".rdnr-incorrect-input-format").first().text();
        var errorInvalidNumberDiv = $("<div>")
            .addClass("anotherRdnr-incorrect-input-format")
            .text(orderNumberInvalidText);

        var removeInput = $("<input>")
            .addClass("false-delivery-form-remove-order-number-input")
            .attr("value", "-")
            .attr("type", "button")
            .on('click', function () {
                orderNumberInputCounter--;
                wrapperDiv.remove();
                checkFields($(this));
            });

        orderNumberControlContainer.append(newOrderNumberInput);
        orderNumberControlContainer.append(removeInput);
        wrapperDiv.append(orderNumberControlContainer);
        wrapperDiv.append(errorEmptyDiv);
        wrapperDiv.append(errorInvalidNumberDiv);

        contactFormContainer.find(".false-delivery-additional-order-numbers-container").first().append(wrapperDiv);
        orderNumberInputCounter++;
    }

    return {
        initFalseDelivery: initFalseDelivery,
        registerFalseDelivery: registerFalseDelivery
    };

})($);

$(function () {
    FalseDeliveryFormJs.initFalseDelivery();
    $(".phone-error-div").hide();
    $(".phone-incorrect-input-format").hide();
    $("#false-delivery-form-submit-button").attr("disabled", "disabled");
});